module.exports = __webpack_public_path__ + "static/personal-loan-page-6a9290b34528e2f181b80ce2efa352a9.png";